import * as React from "react";
import { Block } from "kanopi-components/Block";
import { displayRegistry } from "kw/util/DisplayRegistry";
import { getLabelStyle } from "kanopi-components/Input/FormControl";
import { LabelSmall } from "kanopi-components/typography";
import { StringDisplay } from "kw/util/DisplayRegistry/StringDisplay";
import { toCamelCase } from "kanopi-components/utils/string";
import { useStyletron } from "kanopi-components/theme/useStyletron";
import { WidthContainer } from "kw/util/ChatFlow";

type ListDisplayInputProps = {
  size?: string;
  value?: unknown[];
  valueType?: string;
  valueAccessor?: string;
  labelAccessor?: string;
};

export function ListDisplayInput({
  size,
  value = [],
  valueType,
  valueAccessor,
  labelAccessor,
}: ListDisplayInputProps) {
  const [, theme] = useStyletron();
  const DisplayComponent = displayRegistry.getByType(valueType, StringDisplay);
  return (
    <WidthContainer size={size}>
      {value ? (
        value.map((item) => (
          <Block
            key={JSON.stringify(item)}
            display="flex"
            flexDirection="column"
            alignItems="flex-start"
            justifyContent="center"
            paddingTop="scale400"
            paddingBottom="scale400"
            width="100%"
            overrides={{
              Block: {
                style: {
                  ":not(:last-of-type)": {
                    borderBottom: "1px solid lightgrey",
                  },
                },
                props: {
                  "data-testid": `listDisplay-${toCamelCase(item[labelAccessor])}`,
                },
              },
            }}
          >
            <LabelSmall
              style={getLabelStyle({
                theme,
                size,
              })}
            >
              {item[labelAccessor]}
            </LabelSmall>
            <DisplayComponent answer={item[valueAccessor]} />
          </Block>
        ))
      ) : (
        <Block display="flex" width="100%">
          -
        </Block>
      )}
    </WidthContainer>
  );
}
